import React from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

/**
 * Error component displayed when a user has no employer assigned
 * This happens when a non-admin user tries to access employer-specific routes
 * without having an employer claim in their Firebase token.
 */
export default function NoEmployerError({ message }) {
  const navigate = useNavigate()
  
  const defaultMessage = 'לא הוקצה מעסיק למשתמש - יש לפנות למנהל המערכת'
  
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          textAlign: 'center',
          maxWidth: 500,
        }}
      >
        <ErrorOutlineIcon 
          color="error" 
          sx={{ fontSize: 64, marginBottom: 2 }} 
        />
        <Typography variant="h5" gutterBottom color="error">
          שגיאה בגישה
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {message || defaultMessage}
        </Typography>
        <Box sx={{ marginTop: 3, display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button 
            variant="contained" 
            onClick={() => navigate('/')}
          >
            חזרה לדף הבית
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => window.location.reload()}
          >
            נסה שוב
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
